import { IconType } from 'react-icons';
import { HiOutlineBriefcase, HiOutlineOfficeBuilding } from 'react-icons/hi';
import { RiMoneyPoundCircleLine } from 'react-icons/ri';
import { FiClock, FiCreditCard, FiGrid, FiUserCheck, FiUsers } from 'react-icons/fi';

import { MODULES } from '@vyce/core/src/types';
import { STAFF_MODULES, StaffModuleMeta } from '@vyce/core/src/utils/staffPermissions';
import config from '@vyce/core/src/api/config';

// Keyed on module_system_name — the canonical IAM key. Anything unknown gets a
// neutral icon rather than crashing on an undefined component.
const MODULE_ICONS: Record<string, IconType> = {
  companies: HiOutlineOfficeBuilding,
  pay: RiMoneyPoundCircleLine,
  connect: HiOutlineBriefcase,
  time: FiClock,
  teams: FiUsers,
  management: FiUserCheck,
  billing: FiCreditCard,
  general: FiGrid,
};

export const getModuleIcon = (systemName?: string): IconType =>
  MODULE_ICONS[(systemName || '').toLowerCase()] || FiGrid;

// Same gating as the Edit Permissions dialog: Hiring is hidden while the
// Connect module is flagged as coming soon.
export const getVisibleStaffModules = (): StaffModuleMeta[] =>
  STAFF_MODULES.filter(module => !(config.comingSoon && module.key === MODULES.CONNECT));

export const isComingSoonModule = (systemName?: string) =>
  !!config.comingSoon && (systemName || '').toLowerCase() === 'connect';
